var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBitget(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 89.663,
    height: 24,
    viewBox: "0 0 89.663 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bitget-seeklogo.com",
    transform: "translate(-1.137)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_962",
    "data-name": "Group 962"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_961",
    "data-name": "Group 961"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_122",
    "data-name": "Path 122",
    d: "M90.4,7a.354.354,0,0,1,.4.4V9.6a.354.354,0,0,1-.4.4H88.5v8.8a.354.354,0,0,1-.4.4H85.2a.354.354,0,0,1-.4-.4V9.9H82.9a.354.354,0,0,1-.4-.4V7.3a.367.367,0,0,1,.1-.3h2.2V3.9a.354.354,0,0,1,.4-.4h2.9a.354.354,0,0,1,.4.4V7Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_123",
    "data-name": "Path 123",
    d: "M82.1,12.9a3.73,3.73,0,0,1-.2,1.2c-.1.2-.3.3-.7.3H74a2.376,2.376,0,0,0,1,1.5,3.939,3.939,0,0,0,2,.5,3.749,3.749,0,0,0,1.1-.1,3.379,3.379,0,0,0,1.2-.6.5.5,0,0,1,.6,0l1.3,1.2c.1.1.1.1.1.2a.367.367,0,0,1-.1.3,7.183,7.183,0,0,1-2,1.4,6.042,6.042,0,0,1-2.4.5,7.308,7.308,0,0,1-3.3-.8,6.077,6.077,0,0,1-2.2-2.3,6.406,6.406,0,0,1,0-6.2,5.81,5.81,0,0,1,2.2-2.2A5.326,5.326,0,0,1,76.6,7a5.467,5.467,0,0,1,2.9.8,5.321,5.321,0,0,1,2,2.2A6.527,6.527,0,0,1,82.1,12.9ZM76.5,10a2.767,2.767,0,0,0-1.6.5A2.276,2.276,0,0,0,74,12h4.9a2.195,2.195,0,0,0-.8-1.5A3.022,3.022,0,0,0,76.5,10Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_124",
    "data-name": "Path 124",
    d: "M68.9,7.2a.354.354,0,0,1,.4.4V19.1a3.945,3.945,0,0,1-1,2.9,4.466,4.466,0,0,1-2.4,1.6,14.474,14.474,0,0,1-3,.4,9.246,9.246,0,0,1-2.9-.4,9.861,9.861,0,0,1-2.3-1.1.367.367,0,0,1-.1-.3V22l.9-1.7c.1-.1.2-.2.3-.2H59a5.094,5.094,0,0,0,1.7.7,11.245,11.245,0,0,0,2,.2,5.091,5.091,0,0,0,2.2-.5,1.673,1.673,0,0,0,1-1.7V17.7a4.312,4.312,0,0,1-3.5,1.6,5.467,5.467,0,0,1-2.9-.8,5.827,5.827,0,0,1-2.1-2.3,6.428,6.428,0,0,1-.7-3.1,6.7,6.7,0,0,1,.7-3.1,6.671,6.671,0,0,1,2.1-2.3,4.894,4.894,0,0,1,2.9-.8,4.4,4.4,0,0,1,3.4,1.6l.1-1a.43.43,0,0,1,.4-.4h2.6Zm-6,8.7a2.463,2.463,0,0,0,1.9-.9,2.9,2.9,0,0,0,0-4,2.323,2.323,0,0,0-1.9-.9,2.56,2.56,0,0,0-1.9.8,2.792,2.792,0,0,0-.8,2,2.724,2.724,0,0,0,.7,2A2.459,2.459,0,0,0,62.9,15.9Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_125",
    "data-name": "Path 125",
    d: "M55.5,7a.354.354,0,0,1,.4.4V9.6a.354.354,0,0,1-.4.4H53.6v8.8a.354.354,0,0,1-.4.4H50.3a.367.367,0,0,1-.3-.1V9.9H48a.354.354,0,0,1-.4-.4V7.3a.367.367,0,0,1,.1-.3H50V3.9a.354.354,0,0,1,.4-.4h2.9a.354.354,0,0,1,.4.4V7Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_126",
    "data-name": "Path 126",
    d: "M44.5,6a1.974,1.974,0,0,1-1.4-.6A2.168,2.168,0,0,1,42.6,4a1.816,1.816,0,0,1,.6-1.4A1.612,1.612,0,0,1,44.5,2a1.974,1.974,0,0,1,1.4.6,1.933,1.933,0,0,1,0,2.8A1.816,1.816,0,0,1,44.5,6ZM42.7,7.3a.367.367,0,0,1,.1-.3H46a.354.354,0,0,1,.4.4V18.8a.354.354,0,0,1-.4.4H43.1a.354.354,0,0,1-.4-.4Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_127",
    "data-name": "Path 127",
    d: "M38.1,10a3.9,3.9,0,0,1,2.3,1.5,3.942,3.942,0,0,1,1,2.7,4.319,4.319,0,0,1-1.6,3.7,7.558,7.558,0,0,1-4.7,1.2H29.2a.354.354,0,0,1-.4-.4V2.4a.367.367,0,0,1,.1-.3.349.349,0,0,1,.2-.1H35a5.4,5.4,0,0,1,2.7.6,3.335,3.335,0,0,1,1.7,1.6A4.383,4.383,0,0,1,40,6.5a4.032,4.032,0,0,1-.6,2.2A2.727,2.727,0,0,1,38.1,10ZM36.6,7c0-1-.6-1.6-1.9-1.6H32.5V8.7h2.2a1.955,1.955,0,0,0,1.4-.4A1.9,1.9,0,0,0,36.6,7Zm-1.4,8.8a3.453,3.453,0,0,0,1.8-.5,1.955,1.955,0,0,0,.7-1.5,1.579,1.579,0,0,0-.7-1.5,2.969,2.969,0,0,0-1.8-.5H32.5v4Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_128",
    "data-name": "Path 128",
    d: "M8.1.5A1.606,1.606,0,0,1,9.2,0h2.9a.4.4,0,0,1,.3.7L6.7,6.9H9.9l3.2,3.4H6.7l6.4,6.9H9.2A1.845,1.845,0,0,1,8,16.7l-6.5-7a1.677,1.677,0,0,1,.1-2.2Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_129",
    "data-name": "Path 129",
    d: "M17,23.5a1.656,1.656,0,0,1-1.2.5H12.9a.4.4,0,0,1-.3-.7l5.8-6.2H15.2L12,13.7h6.4L12,6.8h3.9a1.845,1.845,0,0,1,1.2.5l6.5,7a1.569,1.569,0,0,1,0,2.2Z",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBitget);
export default __webpack_public_path__ + "static/media/bitget.8bfeb2d466752367a71e3e2f86ac931b.svg";
export { ForwardRef as ReactComponent };